import { ajax } from "@/assets/js/ajax";
export function getDirectory(data) {
  //法院目录列表
  return ajax({
    url: "court/index",
    type: "get",
    data: data,
  });
}

export function directoryDel(data) {
  //法院删除
  return ajax({
    url: "court/del",
    type: "post",
    data: data,
  });
}

export function directoryInfo(data) {
  //法院详情
  return ajax({
    url: "court/info",
    type: "get",
    data: data,
  });
}

export function directoryEdit(data) {
  //法院修改
  return ajax({
    //url: 'court/edit',
    url: "court/editWithAudit",
    type: "put",
    data: data,
  });
}

export function directoryNameEdit(data) {
  //法院修改
  return ajax({
    //url: 'court/edit',
    url: "court/edit",
    data: data,
  });
}

export function directoryAdd(data) {
  //法院添加
  return ajax({
    url: "court/add",
    type: "post",
    data: data,
  });
}

export function teamAdd(data) {
  //新增团队
  return ajax({
    url: "team/save",
    data: data,
  });
}

export function teamList(data) {
  //团队列表
  return ajax({
    url: "team/index",
    type: "get",
    data: data,
  });
}
export function teamEdit(data) {
  return ajax({
    url: "team/update",
    data: data,
  });
}
export function teamDel(data) {
  return ajax({
    url: "team/delete",
    data: data,
    type: "get",
  });
}

export function bankList(data) {
  return ajax({
    url: "bank/index",
    data: data,
    type: "get",
  });
}

export function bankAdd(data) {
  return ajax({
    url: "bank/add",
    data: data,
  });
}

export function bankEdit(data) {
  return ajax({
    url: "bank/edit",
    data: data,
    type: "put",
  });
}
export function bankDel(data) {
  return ajax({
    url: "bank/del?id=" + data,
    type: "delete",
  });
}

//代理模式

export function agencyList(data) {
  return ajax({
    url: "attorney/list",
    data: data,
    type: "get",
  });
}

export function agencyAdd(data) {
  return ajax({
    url: "attorney/add",
    data: data,
  });
}

export function agencyEdit(data) {
  return ajax({
    url: "attorney/edit",
    data: data,
    type: "post",
  });
}
export function agencyDel(data) {
  return ajax({
    url: "attorney/del",
    type: "post",
    data: data,
  });
}

// 仲裁机构

export function arbOrg(data, type) {
  return ajax({
    url: "/arbOrg/" + type,
    data: data,
    type: type == "index" || type == "info" ? "get" : "post",
  });
}

//根据类型获取选项
export function by_type(data) {
  return ajax({
    url: "option/by_type",
    data: data,
    type: "get",
  });
}
export function by_typeList(data) {
  //添加选项类型
  return ajax({
    url: "option/list",
    type: "get",
    data: data,
  });
}
export function by_typeAdd(data) {
  //添加选项类型
  return ajax({
    url: "option/add",
    type: "post",
    data: data,
  });
}
export function by_typeEdit(data) {
  //添加选项类型
  return ajax({
    url: "option/edit",
    type: "post",
    data: data,
  });
}
export function by_typeDel(data) {
  //删除选项类型
  return ajax({
    url: "option/del",
    type: "post",
    data: data,
  });
}
export function attorneyoptions(id) {
  // 代理人选项
  return ajax({
    url: `attorney/options?agent_model_id=${id}`,
    type: "get",
  });
}

export function stageinfoList(id) {
  // 案件代理人汇总
  return ajax({
    url: `cause/stage/list?cause_id=${id}`,
    type: "get",
  });
}
export function identityVerification(data) {
  //身份验证
  return ajax({
    url: "verify_cert",
    type: "post",
    data: data,
  });
}
